module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/item_06_f153babeffb05b89bf62f190fe296a9f.jpg";